<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
        {{ "bikeshop.menu.checklist_configuration" | translate }}
      </span>
    </div>
  </div>
  <div style="display: flex">
    <div style="margin-left: auto">
      <p-progressSpinner *ngIf="loading" [style]="{ width: '30px', height: '30px' }"
                         strokeWidth="2" fill="transparent" animationDuration=".5s"></p-progressSpinner>
    </div>
    <button style="width: 120px;" type="button" class="iso-round-button alternate"
            (click)="addChecklistItem()">
      {{ 'bikeshop.service_types.add_new' | translate }}
    </button>
  </div>

  <div>

    <div class="content margin-top-16" *ngIf="preServiceChecklistItems && preServiceChecklistItems.length > 0">
      <div class="container-header">
        {{ "bikeshop.checklist.pre_service_checklist" | translate }}
      </div>
      <p-table #checklistTable [columns]="columns" [value]="preServiceChecklistItems">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns"
                [ngStyle]="{'width': col.field === 'couponCode' ? '165px' : 'auto'}">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-checklist let-columns="columns">
          <tr [pSelectableRow]="checklist" (click)="editChecklistItem(checklist)">
            <td *ngFor="let col of columns">
              <div *ngIf="col.type === 'controlType'">
                {{
                checklist[col.field] === "CHECKBOX" ? ('bikeshop.checklist.checkbox' | translate) :
                  checklist[col.field] === "RADIO" ? ('bikeshop.checklist.radio' | translate) :
                    checklist[col.field] === "MULTILINETEXT" ? ('bikeshop.checklist.multilinetext' | translate) :
                      checklist[col.field] === "TRAFFICLIGHT" ? ('bikeshop.checklist.traffic_light' | translate) :
                      ('bikeshop.checklist.text' | translate)
                }}
              </div>
              <div *ngIf="col.type === 'boolean'">

                {{ checklist[col.field] ? ('general.yes' | translate) : ('general.no' | translate) }}
              </div>
              <div *ngIf="col.type === 'color'">
                <span class="color-block"
                      [ngStyle]="{ 'background-color': checklist[col.field] }"></span>
              </div>
              <div *ngIf="col.type === 'string'">
                {{
                checklist[col.field]
                }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="content margin-top-16" *ngIf="mandatoryChecklistItems && mandatoryChecklistItems.length > 0">
      <div class="container-header">
        {{ "bikeshop.checklist.all_services_checklist" | translate }}
      </div>
      <p-table #checklistTable [columns]="columns" [value]="mandatoryChecklistItems">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns"
                [ngStyle]="{'width': col.field === 'couponCode' ? '165px' : 'auto'}">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-checklist let-columns="columns">
          <tr [pSelectableRow]="checklist" (click)="editChecklistItem(checklist)">
            <td *ngFor="let col of columns">
              <div *ngIf="col.type === 'controlType'">
                {{
                checklist[col.field] === "CHECKBOX" ? ('bikeshop.checklist.checkbox' | translate) :
                  checklist[col.field] === "RADIO" ? ('bikeshop.checklist.radio' | translate) :
                    checklist[col.field] === "MULTILINETEXT" ? ('bikeshop.checklist.multilinetext' | translate) :
                checklist[col.field] === "TRAFFICLIGHT" ? ('bikeshop.checklist.traffic_light' | translate) :
                      ('bikeshop.checklist.text' | translate)
                }}
              </div>
              <div *ngIf="col.type === 'boolean'">
                {{ checklist[col.field] ? ('general.yes' | translate) : ('general.no' | translate) }}
              </div>
              <div *ngIf="col.type === 'color'">
                <span class="color-block"
                      [ngStyle]="{ 'background-color': checklist[col.field] }"></span>
              </div>
              <div *ngIf="col.type === 'string'">
                {{
                checklist[col.field]
                }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="content margin-top-16">
      <div class="container-header">
        {{ "bikeshop.checklist.service_type_selection_list" | translate }}
      </div>
      <p-table #checklistTable [columns]="columns" [value]="checklistItems">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns"
                [ngStyle]="{'width': col.field === 'couponCode' ? '165px' : 'auto'}">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-checklist let-columns="columns">
          <tr [pSelectableRow]="checklist" (click)="editChecklistItem(checklist)">
            <td *ngFor="let col of columns">
              <div *ngIf="col.type === 'controlType'">
                {{
                checklist[col.field] === "CHECKBOX" ? ('bikeshop.checklist.checkbox' | translate) :
                  checklist[col.field] === "RADIO" ? ('bikeshop.checklist.radio' | translate) :
                    checklist[col.field] === "MULTILINETEXT" ? ('bikeshop.checklist.multilinetext' | translate) :
                      checklist[col.field] === "TRAFFICLIGHT" ? ('bikeshop.checklist.traffic_light' | translate) :
                        ('bikeshop.checklist.text' | translate)
                }}
              </div>
              <div *ngIf="col.type === 'boolean'">
                {{ checklist[col.field] ? ('general.yes' | translate) : ('general.no' | translate) }}
              </div>
              <div *ngIf="col.type === 'color'">
                <span class="color-block"
                      [ngStyle]="{ 'background-color': checklist[col.field] }"></span>
              </div>
              <div *ngIf="col.type === 'string'">
                {{
                checklist[col.field]
                }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-sidebar #NavSideBar [(visible)]="showChecklistItemDetail" position="right"
           [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="getChecklistItems(); NavSideBar.destroyModal()">
  <div *ngIf="showChecklistItemDetail">
    <app-add-edit-checklist-item [checklistItem]="selectedItem" (close)="close()"></app-add-edit-checklist-item>
  </div>
</p-sidebar>
